
<template>
  <div v-if="payload && payload.images && payload.images.length === 1">
    <responsive-image :desktop="payload.images[0].image" :mobile="payload.images[0].mobileImage" />
  </div>
  <div v-else class="multiple" @click="slide()">
    <Icon data-hover="link" class="iconSize changeSlide hide-for-large" icon="change-slide" />
    <div class="swiper-container" data-hover="slider">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(img, key) in payload.images" :key="key">
          <responsive-image :desktop="img.image" :mobile="img.mobileImage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  props: {
    payload: {
      default: {}
    }
  },
  data() {
    return {
      swiper: null,
      activeIndex: 0,
      sliding: false,
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  },
  mounted() {
    setTimeout(() => {
      this.swiper = new Swiper(".swiper-container", {
        allowTouchMove: false,
        autoHeight: true,
        loop: true,
        roundLengths: true
      });
    }, 100);
  },
  methods: {
    slide() {
      if (this.sliding === false) {
        this.sliding = true;
        this.$store.commit("rotateCursor");
        if (!this.swiper.slideNext()) {
          this.swiper.slideToLoop(0);
          this.swiper.slideNext();
        }
        setTimeout(() => {
          this.sliding = false;
        }, 800);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.cell {
  position: relative;
  overflow: hidden;
  margin-top: 64px;
  margin-bottom: 64px;
  @include breakpoint(medium down) {
    margin-top: 32px;
    margin-bottom: 32px;
  }

  img {
    width: 100%;
  }
}

.sliding-enter {
  @include transform(translateX(100%));
}
.sliding-enter-to {
  @include transform(translateX(0));
}

.sliding-leave-active {
  position: absolute;
  top: 0;
  left: 0;
}

.sliding-enter-active,
.sliding-leave-active {
  -webkit-transition: all 0.8s ease-in-out;
  -moz-transition: all 0.8s ease-in-out;
  -o-transition: all 0.8s ease-in-out;
  transition: all 0.8s ease-in-out;
}

/deep/ .changeSlide {
  position: absolute;
  bottom: 0;
  right: 32px;
  cursor: pointer;
  z-index: 3;
}

.multiple {
  @include breakpoint(medium down) {
    position: relative;
  }
}

.swiper-container {
  .swiper-wrapper {
    width: 100% !important;
    position: relative;
    transform: none !important;
    overflow: hidden;
    z-index: 1;
    .swiper-slide {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      @include transition-duration(0s);
      @include transform(translateX(0));
      &.swiper-slide-prev {
        z-index: 1;
      }
      &.swiper-slide-active {
        @include transition-duration(0.8s);
        z-index: 3;
      }
      &.swiper-slide-next {
        @include transform(translateX(100%));
        z-index: 2;
      }
    }
  }
}
</style>
